import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import useSite from '~/client/hooks/useSite';
import getBadge from '~/client/shared/game/GameThumb/GameBadge/helpers';

const useGameBadge = (game: SingleGameFragment) => {
  const { site } = useSite();
  const badge = getBadge(game, site);
  const label = `game.label_${badge?.type}`;
  const hasBadge = Boolean(badge);
  return { hasBadge, label, bgColor: badge?.color };
};

export default useGameBadge;
